import * as types from '../types';
import { IItemsApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class ItemsHttpApi extends HttpApi implements IItemsApi {
  async listItems(page = 1, limit = 20): Promise<types.PaginatedResponse<types.Item>> {
    // Backend returns { success, data, pagination } at the top level (no nested envelope).
    const response = await this.http.get<types.PaginatedResponse<types.Item>>(
      '/items',
      { params: { page, limit } }
    );
    return response.data;
  }

  async getItem(id: string): Promise<types.Item> {
    const response = await this.http.get<types.APIResponse<types.Item>>(`/items/${id}`);
    return response.data.data;
  }

  async createItem(data: types.CreateItemRequest): Promise<types.Item> {
    const response = await this.http.post<types.APIResponse<types.Item>>('/items', data);
    return response.data.data;
  }

  async updateItem(id: string, data: types.UpdateItemRequest): Promise<types.Item> {
    const response = await this.http.patch<types.APIResponse<types.Item>>(`/items/${id}`, data);
    return response.data.data;
  }

  async deleteItem(id: string): Promise<void> {
    await this.http.delete(`/items/${id}`);
  }

  async listItemCategories(page = 1, limit = 20): Promise<types.PaginatedResponse<types.ItemCategory>> {
    const response = await this.http.get<types.PaginatedResponse<types.ItemCategory>>(
      '/item-categories',
      { params: { page, limit } }
    );
    return response.data;
  }
}
